import React, { useEffect } from 'react'
import Card from 'src/components/riders/rider-portal/common/Card'
import Cross from 'src/components/icons/ui/Cross'
import Modal from 'src/components/riders/rider-portal/common/Modal'
import Skeleton from 'src/components/riders/rider-portal/common/Skeleton'
import Divider from 'src/components/ui/Divider'
import { ICardSource } from 'src/types/rider-portal-state'
import { RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'

interface IPaymentSourceModalProps {
  isOpen: boolean
  loading: boolean
  paymentSource: string | undefined
  riderPaymentSource: ICardSource[]
  getCurrentUserInfo: () => void
  handleSelectSource: (sourceId: string) => void
  onClose: () => void
}

const PaymentSourceModal = ({
  isOpen,
  loading,
  paymentSource,
  riderPaymentSource,
  getCurrentUserInfo,
  handleSelectSource,
  onClose
}: IPaymentSourceModalProps) => {
  const { dataFeedback, trips } = RIDER_PORTAL_UI_MESSAGES

  useEffect(() => {
    if (riderPaymentSource.length === 0) {
      getCurrentUserInfo()
    }
  }, [riderPaymentSource.length, getCurrentUserInfo])

  return (
    <Modal isOpen={isOpen} width={768} onClose={onClose}>
      <>
        <div className='flex items-center justify-between rp-p16'>
          <h3 className='font-black1 font-medium my0 rp-pr24 text-lg'>{trips.paymentSource}</h3>
          <Cross className='icon--18x18 svg-color-black1' onClick={onClose} />
        </div>
        <Divider />
        <div className='rp-p16'>
          {loading ? (
            <div className='flex flex-wrap'>
              <Skeleton className='rp-mt8' text={dataFeedback.retrievingRiderInfo} withBg={true} withLoading={true} />
            </div>
          ) : (
            <>
              {riderPaymentSource.length === 0 ? (
                <div className='flex flex-wrap'>
                  <Skeleton className='rp-mt8' text={dataFeedback.noPaymentSource} withBg={true} withLoading={false} />
                </div>
              ) : (
                <div className='rp-payment-source-container rp-mt8'>
                  {riderPaymentSource.map(({ id, exp_month, exp_year, last4, name }) => (
                    <div
                      key={id}
                      role='button'
                      tabIndex={0}
                      onClick={() => handleSelectSource(id)}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault()
                          handleSelectSource(id)
                        }
                      }}
                    >
                      <Card
                        active={paymentSource ? paymentSource === id : false}
                        className='border-box cursor--pointer h100'
                      >
                        <h4 className='font-black1 font-medium my0 text-md'>{name}</h4>
                        <div className='flex column-gap-12 justify-between rp-mt24'>
                          <p className='font-black1 mb0 mt03 text-sm'>{`**** **** **** ${last4}`}</p>
                          <p className='font-black1 mb0 mt03 text-sm'>{`Expiry: ${exp_month}/${exp_year}`}</p>
                        </div>
                      </Card>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </>
    </Modal>
  )
}

export default PaymentSourceModal



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/create/PaymentSourceModal.tsx